import { useEffect } from 'react';
import { useOrderEditSectionsContext } from '../../../edit/sections/OrderEditSections.context';
import { OrderEditSectionsEnum } from '../../../edit/sections/OrderEditSections.types';
import { OrderTabKey } from '../orderObjectPage.types';

const TAB_TO_SECTION: Partial<Record<OrderTabKey, OrderEditSectionsEnum>> = {
  products: OrderEditSectionsEnum.PRODUCTS,
  overview: OrderEditSectionsEnum.GENERAL_DATA,
  conditions: OrderEditSectionsEnum.ORDER_CONDITIONS,
};

const useOrderObjectTabSectionSync = (activeTab: OrderTabKey) => {
  const { handleChangeCurrentSection } = useOrderEditSectionsContext();

  useEffect(() => {
    const section = TAB_TO_SECTION[activeTab];
    if (section) {
      handleChangeCurrentSection(section);
    }
  }, [activeTab, handleChangeCurrentSection]);
};

export default useOrderObjectTabSectionSync;
